import { useNavigate } from "react-router-dom";
import { ROUTES } from "@/app/routes";
import { ChangeAddressResult, SuccessCheckIcon } from "./ChangeAddressResult";

export default function ChangeAddressSuccessPage() {
  const navigate = useNavigate();

  return (
    <ChangeAddressResult
      screenTitle="เปลี่ยนที่อยู่จัดส่งเอกสาร"
      showHeader={false}
      icon={<SuccessCheckIcon />}
      status="ทำรายการสำเร็จ"
      statusTone="success"
      heading="เปลี่ยนที่อยู่จัดส่งเอกสารแล้ว"
      description="เอกสารในอนาคตจะจัดส่งไปยังที่อยู่ใหม่"
      actionLabel="กลับสู่หน้าตั้งค่า"
      onAction={() => {
        void navigate(ROUTES.settings.account, { replace: true });
      }}
    />
  );
}
